/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Empty_SearchInputs */

const vi_media_empty_search = /** @type {(inputs: Media_Empty_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có file nào khớp từ khoá. Thử từ khác.`)
};

/**

* @param {Media_Empty_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_empty_search = /** @type {((inputs?: Media_Empty_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Empty_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_empty_search(inputs)
});